<template>
  <div class="progress-bar">
    <div class="progress-bar-content">
      <div class="progress-bar-content-base">
        <div
          class="progress-bar-content-base-progress"
          :style="{ width: `${percentage}%` }"
        ></div>
      </div>
      <p class="progress-bar-content-value">{{ percentage }}%</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questionArray: Array,
    currentQuestionIndex: Number
  },

  computed: {
    percentage () {
      return parseInt(
        (this.currentQuestionIndex / (this.questionArray.length - 1)) * 100
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";
.progress-bar {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;

  &-content {
    display: flex;
    align-items: center;

    &-base {
      background-color: #f2f3f5;
      width: 240px;
      height: 2px;

      &-progress {
        background-color: #596afd;
        height: 100%;
        width: 68%;
      }
    }

    &-value {
      color: #596afd;
      font-size: 14px;
      margin-left: 8px;
    }
  }
}
</style>
